import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import Home from "@/pages/Home";
import Database from "@/pages/Database";
import TutorialDetail from "@/pages/TutorialDetail";
import Categories from "@/pages/Categories";
import AIGenerator from "@/pages/AIGenerator";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center font-mono text-[#00ff66]">
        <span className="cursor-blink">authenticating</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function Shell() {
  return (
    <div className="App min-h-screen cyber-grid scanlines relative">
      <Navbar />
      <main className="pt-16 relative z-10">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/database" element={<Database />} />
          <Route path="/tutorial/:id" element={<TutorialDetail />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/ai-generator" element={<AIGenerator />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
        </Routes>
      </main>
      <Toaster position="top-right" theme="dark" offset={{ top: "76px" }} mobileOffset={{ top: "72px" }} />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
